import { AuthService } from '../auth.service';
import { CookieService } from 'ngx-cookie-service';

import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth-automatic',
  template: 'Automatic Login - {{ signInIsRunning() }}',
})
export class AuthAutomaticComponent implements OnInit {
  private auth = inject(AuthService);
  public router = inject(Router);
  private cookieService = inject(CookieService);
  public signInIsRunning = signal(false);

  errorMessage = signal<string>(undefined);
  ngOnInit(): void {
    if (!this.signInIsRunning()) {
      this.login();
    }
  }
  async login() {
    this.signInIsRunning.set(true);
    this.auth.automaticCredentials().then(user => {
      this.signInIsRunning.set(false);
      this.auth.handleAuthentication(user);
      this.router.navigate(['/']);
    });
  }
}
